import React, { useState } from "react";
import ReactECharts from "echarts-for-react";

import Table from "../../components/Table";
import { Card, CardContent } from "../../components/Card";
import Grid from "../../components/Grid";
import Text from "../../components/Text";



export default function CustomerStatisticsTable() {
  const data = [];
  const [newData, setNewData] = useState({
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
  });
  /*統計圖*/
  // const getOption = () => {
  //   if (history.location.state) {
  //     return ({
  //       title: {
  //         text: (history.location.state.rangeObject && history.location.state.rangeObject.label) +
  //           ":" + (history.location.state.auctionQuotesObject && history.location.state.auctionQuotesObject.label),
  //         x: "center"
  //       },
  //       tooltip: {
  //         trigger: "item",
  //         formatter: "{a} <br/>{b} : {c} ({d}%)"
  //       },
  //       series: [
  //         {
  //           name: "來源",
  //           type: "pie",
  //           radius: "55%",
  //           center: ["50%", "60%"],
  //           animationDuration: 5000,
  //           data: history.location.state.selectData,
  //           itemStyle: {
  //             emphasis: {
  //               shadowBlur: 10,
  //               shadowOffsetX: 0,
  //               shadowColor: "rgba(0, 0, 0, 0.5)"
  //             }
  //           }
  //         }
  //       ]
  //     })
  //   }
  // };
  // const Option = () => {
  //   if (history.location.state) {
  //     return ({
  //       xAxis: {
  //         type: 'category',
  //         data: history.location.state.selectData.map((item) => { return item.name })
  //       },
  //       yAxis: {
  //         type: 'value'
  //       },
  //       series: [{
  //         data: history.location.state.selectData.map((item) => { return item.value }),
  //         type: 'bar'
  //       }]
  //     })
  //   }
  // };
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const statisticsData=[];
  const rows = ["付費未上課","已上課未加盟","付訂未加盟","面談未上課","電訪未上課"];
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Table
            data={data}
            tableWidth={2}
            header={[
              "人員/統計",
              "總計/人",
              "未處理/人",
              "加盟數/人",
              "付費未上課",
              "已上課未加盟",
              "付訂未加盟",
              "面談未上課",
              "電訪未上課",
            ]}
            columns={[]}
          />
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
              <Table
              data={statisticsData}
              />
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <ReactECharts
            option={getOption()}
            /> */}
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <Grid container spacing={1}>
          {/* <ReactECharts
          option={Option()}
          /> */}
        </Grid>
      </CardContent>
    </Card>
  );
}
